import React, {FC, useState, ChangeEvent, useEffect, ElementType}  from 'react';

import {
  EditNote, DraftsOutlined, HourglassEmpty, Autorenew,
  CheckCircle, DoneAll, Cancel, Block, Flag
} from '@mui/icons-material';
import { useTranslation  } from 'react-i18next';
import { isFalsy } from 'utility-types';
import { Chip } from '@mui/material';


//import Checkbox from '@mui/material/Checkbox';
//import ListSubheader from '@mui/material/ListSubheader';

//import { blue } from '@mui/material/colors';
// import { useRecoilValue } from 'recoil';
// import { currentUserSessionAtom } from 'library/store';


export interface StatusChipProps {
    status: string
}

function  StatusChip<T>(props: StatusChipProps) {

    const { t, i18n } = useTranslation();

    //const {language: lg} = useRecoilValue(currentUserSessionAtom);

    const {status} = props;

    const statusLabels: Record<string, string> = {
        "00": `⏳ ${t('Not saved')}`, 
        "95": `⏳ ${t('Proposition')} / ${t('Not validated')}`, 
        "10": `✅ ${t('Validated')}`,
        "80": `❌ ${t('Cancelled')}`, 
        "85": `🚫 ${t('Proposition Cancelled')}`,
    };

    // Status-to-color map using sx for custom background/text color
// const statusStyles: Record<string, { bg: string; color: string }> = {
//   "95": { bg: "#FFC107", color: "#000" },            // Yellow
//   "10": { bg: "#4CAF50", color: "#fff" },            // Green
//   "80": { bg: "#F44336", color: "#fff" },            // Red
//   "85": { bg: "#9E9E9E", color: "#fff" },            // Grey
// };

const statusStyles: Record<string, { bg: string; color: string; icon: React.ReactNode }> = {
  "00": {
    bg: "#E0E0E0", color: "#424242", icon: <EditNote fontSize="small" />,
  },
  "95": {
    bg: "#FFF8E1", color: "#FF8F00", icon: <HourglassEmpty fontSize="small" />,
  },
  "05": {
    bg: "#E1F5FE", color: "#0288D1", icon: <Autorenew fontSize="small" />,
  },
  "01": {
    bg: "#E1F5FE", color: "#0288D1", icon: <Autorenew fontSize="small" />,
  },
  "10": {
    bg: "#E8F5E9", color: "#388E3C", icon: <CheckCircle fontSize="small" />,
  },
  "90": {
    bg: "#ECEFF1", color: "#455A64", icon: <DoneAll fontSize="small" />,
  },
  "80": {
    bg: "#FFEBEE", color: "#D32F2F", icon: <Cancel fontSize="small" />,

  },
  "85": {
    bg: "#F5F5F5", color: "#616161", icon: <Block fontSize="small" />,
  },
  "50": {
    bg: "#FFF3E0", color: "#F57C00", icon: <Flag fontSize="small" />,
  },
};

// const statusLabels: Record<string, string> = {
//   "Proposition": "⏳ Proposition",
//   "Validated": "✅ Validated",
//   "Cancelled": "❌ Cancelled",
//   "Proposition Cancelled": "🚫 Cancelled (Not Validated)",
// };

    const label = statusLabels[status] || status;
    const style = statusStyles[status] || { bg: '#E0E0E0', color: '#000' };

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: style.bg,
        color: style.color,
        fontWeight: 500,
        borderRadius: '8px',
      }}
    />
  );
}

export default StatusChip;